import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaLock } from 'react-icons/fa';
import { GoEyeClosed } from 'react-icons/go'

export const SlateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  padding: 80px 0px;
  background-size: 100% auto;
  overflow-x:hidden;
`;

export const FormH1 = styled.h1`
  margin-top: 10px;
  margin-bottom: 10px;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
   @media screen and (max-width: 450px) {
    margin-bottom: 2px;
  }
`;

export const FormH4 = styled.h4`
  padding: 0px 0px;
//   margin-bottom: 1px;
  font-size: 12px;
  color: ${({ errorText }) => (errorText ? 'red' : '#f5f5f5')};
  font-weight: bold;
  text-align: center;
   @media screen and (max-width: 450px) {
    max-width: 300px;
    font-size: 10px;
  }

`;

export const FilterWrap = styled.div`
  display: flex;
  flex-direction: row;
  color: #fff;
  padding: 10px 0;
  background-size: 100% auto;
  align-items: center;
  justify-content: center;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: gray;

  @media screen and (min-width: 490px){
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: grid;
  justify-content: center;
`;

export const FormInput = styled.input`
  border: none;
  border-radius: 4px;
  padding: 16px 16px;
  
  @media screen and (max-width:490px){
    padding: 12px 12px;
    max-width: 100px;
  }
`;

export const NextButton = styled.button`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 30px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin-left: 8px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#ffffff')};
  }

  @media screen and (max-width: 490px){
    margin-left: 8px;
    margin-right: 4px;
    margin-top: 4px;
    padding: 5px 10px;
  }
`;

export const Select = styled.select`
  width: auto;
  height: 42px;
  background: white;
  color: gray;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
  @media screen and (min-width: 490px){
    margin: auto;
    margin-left: 10px;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardContainer = styled.div`
   display: grid;
   margin-top: 20px;
   grid-template-columns: repeat(3, 300px); /* 3 columns of 200px each */
   grid-gap: 20px; /* optional spacing between items */
   justify-content: center; /* optional: center the grid horizontally */
   overflow-y: scroll;

  @media screen and (max-width: 490px) {
    grid-template-columns: repeat(3, 110px); /* 3 columns of 200px each */
    grid-gap: 12px;
    padding: 6px 6px;
  }
`;

export const Card = styled.div`
  background-color: #222831;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-width: 110px;

  @media screen and (min-width:490px){
    height: 200px;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  align-items: center;
`;

export const TopLine = styled.div`
  color: #006ee6;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 2px;
  
  font-size: 10px;

  @media screen and (min-width: 490px){
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 16px;
  }
`;
export const SelectButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  justify-self: center;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  }

  
  @media screen and (max-width: 500px){
    margin-top: 0px;
  }
`;
